import React, { Fragment, Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import UsuarioPerfil from "./UsuarioPerfil";
import { buscarUsuarioLogado } from "./actions";

class Usuario extends Component {
  componentDidMount() {
    this.props.buscarUsuarioLogado();
  }
  render() {
    return <Fragment>
      <UsuarioPerfil className="border-light"  {...this.props.usuario} />
    </Fragment>
  }
}

const mapStateToProps = state => ({
  usuario: state.usuario.usuarioLogado
});

const mapDispatchToProps = dispatch => bindActionCreators({
  buscarUsuarioLogado
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Usuario);




// WEBPACK FOOTER //
// ./src/componentes/usuario/index.js